//console.log("collections.js");

//Single Atc Button

let setSingleAtcBtn = function (singleProduct) {
  let singleAtcBtns = singleProduct.querySelectorAll(".single-atc-btn");

  if (singleAtcBtns.length === 0) {
  } else {
    singleAtcBtns.forEach((item) => {
      let idData = item.dataset.id;

      if (!idData) return;

      let singleID = parseInt(idData, 10);

      item.addEventListener("click", function (event) {
        event.preventDefault();

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: singleID,
            quantity: 1,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            window.coAccessibility?.openDialog(
              document.querySelector("#side-cart"),
              item,
            );

            displayCart();
          })
          .catch((error) => console.error("Error adding item to cart:", error));
      });
    });
  }
};

let removeShoeComma = function (singleProduct) {
  let sizeButtons = singleProduct.querySelectorAll(
    ".desktop-plp-add-to-cart.sizes .atc-btn",
  );

  if (sizeButtons.length > 0) {
    const lastBtn = sizeButtons[sizeButtons.length - 1];
    lastBtn.textContent = lastBtn.textContent.replace(/,+\s\*$/, "");
  }
};

// Swipe Images

const hydrateGallerySlide = function (slide) {
  const image = slide ? slide.querySelector("img[data-src]") : null;

  if (!image) return;

  if (image.dataset.srcset) {
    image.srcset = image.dataset.srcset;
    image.removeAttribute("data-srcset");
  }

  image.src = image.dataset.src;
  image.removeAttribute("data-src");
};

const hydrateGallerySlides = function (swiper) {
  [-1, 0, 1].forEach((offset) => {
    hydrateGallerySlide(swiper.slides[swiper.activeIndex + offset]);
  });
};

// Reset special product galleries when returning to the collection page.
// pageshow also runs when the browser restores the page from its back/forward cache.
window.addEventListener("pageshow", function () {
  document
    .querySelectorAll(".gallery-swiper.special")
    .forEach(function (gallery) {
      const swiper = gallery.swiper;

      if (!swiper || swiper.destroyed) return;

      swiper.slideTo(0, 0);
      hydrateGallerySlides(swiper);
    });
});

const setProduct = function (singleProduct) {
  if (singleProduct.dataset.status === "dynamic") return;

  let addSwiper = singleProduct.querySelector(".gallery-swiper");

  if (addSwiper && !addSwiper.swiper && typeof Swiper === "function") {
    const paginationEl = addSwiper.classList.contains("special")
      ? addSwiper.querySelector(".swiper-pagination")
      : null;

    new Swiper(addSwiper, {
      loop: false,
      watchOverflow: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: "bullets",
            clickable: false,
          }
        : false,
      navigation: {
        nextEl: addSwiper.querySelector(".swiper-button-next"),
        prevEl: addSwiper.querySelector(".swiper-button-prev"),
      },
      on: {
        init: function (swiper) {
          hydrateGallerySlides(swiper);
        },
        slideChange: function (swiper) {
          hydrateGallerySlides(swiper);
        },
      },
    });
  }

  let plpAtc = singleProduct.querySelector(".plp-add-to-cart");

  if (plpAtc) {
    let togglePLPAtc = plpAtc.querySelector(".toggle-atc-btn");

    if (togglePLPAtc) {
      togglePLPAtc.addEventListener("click", function (event) {
        event.preventDefault();
        plpAtc.classList.add("active");
      });
    }
  }

  setSingleAtcBtn(singleProduct);
  removeShoeComma(singleProduct);

  singleProduct.dataset.status = "dynamic";
};

const syncProductImageSizes = function (root) {
  const activeBtn = document.querySelector(".toggle-view .toggle-btn.active");
  let imageSizes = "(min-width: 1000px) 25vw, 50vw";

  if (activeBtn?.classList.contains("two-view")) {
    imageSizes = "(min-width: 1000px) 50vw, 50vw";
  } else if (activeBtn?.classList.contains("six-view")) {
    imageSizes = "(min-width: 1000px) 16.6667vw, 50vw";
  }

  root
    .querySelectorAll(".gallery-swiper img, .plp-product-image:not(.xf)")
    .forEach(function (image) {
      image.sizes = imageSizes;
    });
};

const productObserver =
  "IntersectionObserver" in window
    ? new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            setProduct(entry.target);
            syncProductImageSizes(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: "500px 0px",
        },
      )
    : null;

const initializeProductWhenVisible = function (product) {
  if (!product) return;

  if (productObserver) {
    productObserver.observe(product);
  } else {
    setProduct(product);
  }
};

function initializeHybridCollectionLoading(grid) {
  const trigger = document.querySelector("#collection-load-trigger");
  const controls = document.querySelector("#collection-load-controls");
  const button = document.querySelector("#collection-load-button");
  const status = document.querySelector("#collection-load-status");
  const label = button?.querySelector(".collection-load-label");
  const icon = button?.querySelector(".collection-load-icon");

  if (!grid || !trigger || !controls || !button || !status || !label || !icon) {
    return false;
  }

  if (grid.dataset.hybridLoading === "true") return true;

  grid.dataset.hybridLoading = "true";

  const initialPage = Number(grid.dataset.currentPage) || 1;
  const autoLimit = Math.max(
    0,
    parseInt(grid.dataset.autoLoadBatches, 10) || 0,
  );

  const loadedUrls = new Set();

  let currentPage = initialPage;
  let nextUrl = grid.dataset.nextUrl || null;
  let loadedBatches = 0;
  let automaticBatches = 0;
  let loading = false;
  let failed = false;
  let automatic = autoLimit > 0 && "IntersectionObserver" in window;
  let observer = null;

  function renderControl() {
    const complete = !nextUrl;

    controls.hidden = complete ? loadedBatches === 0 : automatic;
    button.dataset.action = complete ? "back-to-top" : "load-more";
    button.setAttribute("aria-disabled", String(loading));

    label.textContent = loading
      ? "Loading..."
      : complete
        ? "Scroll back to top"
        : failed
          ? "Retry loading products"
          : "Load more products";

    icon.textContent = complete ? "↑" : "+";
    grid.setAttribute("aria-busy", String(loading));
  }

  function focusNewProduct(items) {
    const card = items.find(function (item) {
      return (
        item.matches(".product:not(.editorial-image):not(.editorial-video)") &&
        item.getClientRects().length > 0
      );
    });

    if (!card) return;

    const links = Array.from(card.querySelectorAll("a.title[href]")).concat(
      Array.from(card.querySelectorAll("a[href]")),
    );

    const link = links.find(function (item) {
      return (
        item.getAttribute("role") !== "button" &&
        item.getClientRects().length > 0 &&
        !item.closest('[inert], [hidden], [aria-hidden="true"]') &&
        new URL(item.href).pathname.includes("/products/")
      );
    });

    if (link) {
      link.focus();
    } else {
      card.setAttribute("tabindex", "-1");
      card.focus();
    }
  }

  async function loadNextBatch(manual) {
    if (loading || !nextUrl) return;

    if (manual) automatic = false;
    if (observer) observer.unobserve(trigger);

    let focusMoved = false;

    function trackFocus(event) {
      if (event.target !== button) focusMoved = true;
    }

    if (manual) document.addEventListener("focusin", trackFocus);

    loading = true;
    failed = false;
    renderControl();

    status.textContent = "Loading more products.";

    const abortController = new AbortController();

    const timeout = window.setTimeout(function () {
      abortController.abort();
    }, 20000);

    try {
      const requestUrl = new URL(nextUrl, window.location.href);

      if (
        requestUrl.origin !== window.location.origin ||
        requestUrl.pathname !== window.location.pathname ||
        loadedUrls.has(requestUrl.href)
      ) {
        throw new Error("Invalid or repeated collection page.");
      }

      const response = await fetch(requestUrl.href, {
        signal: abortController.signal,
      });

      if (!response.ok) {
        throw new Error("Collection request failed: " + response.status);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fetchedGrid = doc.querySelector("#collection-con");
      const fetchedPage = Number(fetchedGrid?.dataset.currentPage);
      const items = fetchedGrid ? Array.from(fetchedGrid.children) : [];

      if (
        !items.some(function (item) {
          return item.matches(".product");
        }) ||
        fetchedPage !== currentPage + 1
      ) {
        throw new Error(
          "The response did not contain the next collection batch.",
        );
      }

      const fragment = document.createDocumentFragment();

      items.forEach(function (item) {
        fragment.appendChild(item);
      });

      grid.appendChild(fragment);

      loadedUrls.add(requestUrl.href);
      currentPage = fetchedPage;
      nextUrl = fetchedGrid.dataset.nextUrl || null;
      loadedBatches += 1;

      if (!manual) automaticBatches += 1;
      if (!nextUrl || automaticBatches >= autoLimit) automatic = false;

      grid.dataset.currentPage = String(currentPage);
      grid.dataset.nextUrl = nextUrl || "";

      items
        .filter(function (item) {
          return item.matches(".product");
        })
        .forEach(function (item) {
          try {
            initializeProductWhenVisible(item);
          } catch (error) {
            console.error("Could not initialize a loaded product tile:", error);
          }
        });

      if (manual && !focusMoved && document.activeElement === button) {
        focusNewProduct(items);
      }

      const pageSize = Number(fetchedGrid.dataset.pageSize);
      const total = Number(fetchedGrid.dataset.totalProducts);

      const count = Math.max(
        0,
        Math.min(pageSize, total - (currentPage - 1) * pageSize),
      );

      const message =
        count > 0 ? count + " more products loaded." : "More products loaded.";

      status.textContent = nextUrl
        ? message + (automatic ? "" : " Use Load more products to continue.")
        : initialPage === 1
          ? "All products loaded."
          : "All remaining products loaded. End of collection reached.";
    } catch (error) {
      failed = true;
      automatic = false;

      status.textContent =
        "Products could not be loaded. Use Retry loading products to try again.";

      console.error("Failed to fetch next collection page:", error);
    } finally {
      window.clearTimeout(timeout);
      document.removeEventListener("focusin", trackFocus);

      loading = false;
      renderControl();

      if (automatic && nextUrl && observer) observer.observe(trigger);
    }
  }

  let suppressClickUntil = 0;

  function activateLoadButton() {
    if (loading) return;

    if (nextUrl) {
      loadNextBatch(true);
      return;
    }

    const topTarget =
      document.querySelector("main .page-head h1") ||
      document.querySelector("#MainContent") ||
      grid;

    if (!topTarget.hasAttribute("tabindex")) {
      topTarget.setAttribute("tabindex", "-1");
    }

    topTarget.focus({ preventScroll: true });

    window.scrollTo({
      top: 0,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "instant"
        : "smooth",
    });
  }

  button.addEventListener("pointerup", function (event) {
    if (event.pointerType !== "touch") return;

    event.preventDefault();
    suppressClickUntil = Date.now() + 700;
    activateLoadButton();
  });

  button.addEventListener("click", function (event) {
    if (Date.now() < suppressClickUntil) {
      event.preventDefault();
      return;
    }

    activateLoadButton();
  });

  if (automatic) {
    observer = new IntersectionObserver(
      function (entries) {
        if (
          automatic &&
          entries.some(function (entry) {
            return entry.isIntersecting;
          })
        ) {
          loadNextBatch(false);
        }
      },
      {
        rootMargin: "200px 0px",
        threshold: 0,
      },
    );
  }

  const pagination = grid.parentElement.querySelector(".pagination");

  if (pagination) {
    pagination.hidden = initialPage === 1;
    pagination.classList.add("collection-pagination-fallback");

    if (initialPage > 1) {
      pagination
        .querySelectorAll(".load-more-btn, #paginate-next")
        .forEach(function (link) {
          link.hidden = true;
        });
    }
  }

  renderControl();

  if (observer && nextUrl) observer.observe(trigger);

  return true;
}

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("#collection-con .product")
    .forEach(initializeProductWhenVisible);

  const collectionCon = document.querySelector("#collection-con");

  if (initializeHybridCollectionLoading(collectionCon)) return;

  const nextBtn = document.querySelector("#paginate-next");
  const loadMoreBtn = document.querySelector(".load-more-btn");
  const pagination = document.querySelector(".pagination");

  let nextUrl = nextBtn?.getAttribute("href");
  let loading = false;

  if (nextUrl && collectionCon) {
    const trigger = document.createElement("div");

    trigger.id = "scroll-trigger";
    trigger.style.height = "1px";

    pagination.parentNode.insertBefore(trigger, pagination);

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: "#scroll-trigger",
      triggerHook: 1,
    })
      .addTo(controller)
      .on("enter", function () {
        if (!loading && nextUrl) {
          loading = true;
          fetchNextPage(nextUrl);
        }
      });
  }

  function fetchNextPage(url) {
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelectorAll("#collection-con .product");
        const newNextBtn = doc.querySelector("#paginate-next");

        newProducts.forEach((product) => {
          collectionCon.appendChild(product);
          initializeProductWhenVisible(product);
        });

        if (newNextBtn) {
          nextUrl = newNextBtn.getAttribute("href");
        } else {
          nextUrl = null;

          pagination?.remove();

          if (loadMoreBtn) {
            loadMoreBtn.classList.add("hide");
          }
        }

        if (newProducts.length === 0) {
          nextUrl = null;
          pagination?.remove();

          if (loadMoreBtn) {
            loadMoreBtn.classList.add("hide");
          }
        }

        loading = false;
      })
      .catch((err) => {
        console.error("Failed to fetch next page:", err);
        loading = false;
      });
  }
});

//Filters

let filters = document.querySelector("#main-filters");
let openFiltersBtn = document.querySelectorAll(".filters-btn");
let closeFiltersBtn = document.querySelectorAll(".close-filters-btn");
let filtersSidePop = document.querySelector(".filters-side-pop");
let lastFiltersTrigger = null;

openFiltersBtn.forEach(function (btn) {
  btn.addEventListener("click", function (event) {
    event.preventDefault();

    lastFiltersTrigger = btn;

    filtersSidePop.classList.add("active");
    filtersSidePop.setAttribute("aria-hidden", "false");
    filtersSidePop.removeAttribute("inert");

    btn.setAttribute("aria-expanded", "true");

    document.body.classList.add("no-scroll");

    filtersSidePop.querySelector(".close-filters-btn")?.focus();
  });
});

closeFiltersBtn.forEach(function (btn) {
  btn.addEventListener("click", function (event) {
    event.preventDefault();

    filtersSidePop.classList.remove("active");
    filtersSidePop.setAttribute("aria-hidden", "true");
    filtersSidePop.setAttribute("inert", "");

    openFiltersBtn.forEach(function (button) {
      button.setAttribute("aria-expanded", "false");
    });

    document.body.classList.remove("no-scroll");

    if (lastFiltersTrigger && document.contains(lastFiltersTrigger)) {
      lastFiltersTrigger.focus();
    }

    lastFiltersTrigger = null;

    Cookies.remove("filter-state");

    let checkFilterState = Cookies.get("filter-state");

    console.log(checkFilterState);
  });
});

if (filtersSidePop) {
  filtersSidePop
    .querySelectorAll("details.filter-block")
    .forEach(function (group) {
      function syncFilterGroup() {
        group.classList.toggle("open", group.open);
      }

      group.addEventListener("toggle", syncFilterGroup);
      syncFilterGroup();
    });
}

document
  .querySelectorAll('.filter-form input[type="checkbox"]')
  .forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      const form = document.querySelector(".filter-form");
      const resultsCount = document.querySelector("#results-count");

      if (resultsCount) {
        resultsCount.innerHTML = "...";
      }

      const params = new URLSearchParams(new FormData(form));

      const sortParam = new URLSearchParams(window.location.search).get(
        "sort_by",
      );

      if (sortParam) params.set("sort_by", sortParam);

      const url = `${window.location.pathname}?${params.toString()}`;

      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newCount = doc.querySelector("#results-count");

          if (newCount && resultsCount) {
            resultsCount.innerHTML = newCount.innerHTML;
          }
        })
        .catch((err) => {
          console.error("Error fetching filtered results:", err);

          if (resultsCount) {
            resultsCount.innerHTML = "Error";
          }
        });
    });
  });

//Views

let toggleView = document.querySelector(".toggle-view");
let collectionCon = document.querySelector("#collection-con");

if (toggleView && collectionCon) {
  let viewBtn = toggleView.querySelector(".view-btn");
  let toggleBtns = toggleView.querySelectorAll(".toggle-btn");

  function updateCollectionView(activeBtn) {
    collectionCon.classList.remove("two-view", "four-view", "six-view");

    if (activeBtn.classList.contains("two-view")) {
      collectionCon.classList.add("two-view");
    } else if (activeBtn.classList.contains("six-view")) {
      collectionCon.classList.add("six-view");
    }

    syncProductImageSizes(collectionCon);

    toggleBtns.forEach(function (button) {
      button.setAttribute(
        "aria-pressed",
        button === activeBtn ? "true" : "false",
      );
    });
  }

  viewBtn.addEventListener("click", function (e) {
    e.preventDefault();

    let activeIndex = 0;

    for (let i = 0; i < toggleBtns.length; i++) {
      if (toggleBtns[i].classList.contains("active")) {
        activeIndex = i;
        break;
      }
    }

    toggleBtns[activeIndex].classList.remove("active");

    let nextIndex = (activeIndex + 1) % toggleBtns.length;
    let nextBtn = toggleBtns[nextIndex];

    nextBtn.classList.add("active");

    updateCollectionView(nextBtn);
  });

  toggleBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      toggleBtns.forEach((b) => b.classList.remove("active"));

      btn.classList.add("active");

      updateCollectionView(btn);
    });
  });
}

let homeSwipers = document.querySelectorAll(".collection-swiper");

if (homeSwipers.length > 0) {
  homeSwipers.forEach((homeSwiper) => {
    new Swiper(homeSwiper, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 2,
      draggable: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      wrapperClass: "collection-wrapper",
      slideClass: "collection-slide",
      navigation: {
        nextEl: ".arrows .right",
        prevEl: ".arrows .left",
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 2,
        },
        880: {
          slidesPerView: 3,
          spaceBetween: 2,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 2,
        },
      },
      on: {
        init: function () {
          this.slides.forEach((slide) => {
            slide.classList.add("finished-loading");
          });
        },
      },
    });
  });
}
